import { BuildingProcess16 } from '@cian/ui-kit';
import { Video16, Comments16 } from '@cian/ui-kit/icons';
import { plural } from '@cian/utils';
import * as React from 'react';

import { IconedLink } from './IconedLink';
import * as styles from './newbuildingFeatures.css';
import { trackVideosFeatureClick, trackReviewsFeatureClick, trackConstructionProgressFeatureClick } from './trackings';
import { INewbuildingFeatures } from '../../types/newobject/newbuildingFeatures';

export interface INewbuildingFeaturesProps {
  newbuildingFeatures: INewbuildingFeatures;
  url: string | null;
}

export const NewbuildingFeatures = (props: INewbuildingFeaturesProps) => {
  const { newbuildingFeatures, url } = props;
  const { videosCount = 0, reviewsCount = 0, hasProgressOfConstructions } = newbuildingFeatures;

  return (
    <ul className={styles['container']}>
      <li className={styles['item']}>
        <IconedLink
          text="Ход строительства"
          icon={<BuildingProcess16 color="current_color" />}
          isDisabled={!url || !hasProgressOfConstructions}
          link={`${url}hod-stroitelstva/`}
          onClick={trackConstructionProgressFeatureClick}
        />
      </li>
      <li className={styles['item']}>
        <IconedLink
          text={`${videosCount} видео`}
          icon={<Video16 color="current_color" />}
          isDisabled={Boolean(!url || videosCount === 0)}
          link={`${url}?open_video=1`}
          onClick={trackVideosFeatureClick}
        />
      </li>
      <li className={styles['item']}>
        <IconedLink
          text={`${reviewsCount} ${plural(reviewsCount, ['отзыв', 'отзыва', 'отзывов'])}`}
          icon={<Comments16 color="current_color" />}
          isDisabled={Boolean(!url || reviewsCount === 0)}
          link={`${url}otzyvy`}
          onClick={trackReviewsFeatureClick}
        />
      </li>
    </ul>
  );
};
